module.exports = __webpack_public_path__ + "static/media/card.be17b80f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/user/card.svg
// module id = 619
// module chunks = 1